import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import { getPwaConfig, getPwaMode } from "./config/pwa";
import "./styles.css";

const pwaConfig = getPwaConfig();
document.documentElement.dataset.pwa = getPwaMode();
document.title = pwaConfig.name;
const manifestLink = document.createElement("link");
manifestLink.rel = "manifest";
manifestLink.href = pwaConfig.manifest;
document.head.appendChild(manifestLink);
document.querySelector('meta[name="theme-color"]')?.setAttribute("content", getPwaMode() === "campo" ? "#17675f" : getPwaMode() === "cliente" ? "#22577a" : "#123047");

window.addEventListener("beforeinstallprompt", (event) => {
  event.preventDefault();
  window.wellInstallPrompt = event;
  window.dispatchEvent(new Event("well:install-ready"));
});
window.addEventListener("appinstalled", () => {
  window.wellInstallPrompt = null;
  localStorage.setItem("well_app_installed", "1");
  window.dispatchEvent(new Event("well:app-installed"));
});

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => navigator.serviceWorker.register(pwaConfig.serviceWorker));
}
